module.exports = __webpack_public_path__ + "static/media/ag.5120cf20.svg";